

import { Pipe, PipeTransform } from '@angular/core';
import { utcToZonedTime, format } from 'date-fns-tz';

export function localTime(timezone: string): string {
  const localDate = utcToZonedTime(new Date(), timezone);

  return format(localDate, 'h:mma z', timezone ? { timeZone: timezone } : null);
}

@Pipe({
  name: 'localTime',
})
export class LocalTimePipe implements PipeTransform {
  transform(timezone: string) {
    return localTime(timezone);
  }
}
